
  <div class="container-fluid py-3 px-4 left-menu-space" id="divMainContainer">
    <div class="page-title-box d-flex row bd-highlight">
      <h4 class="mb-0 f-bold-dubai text-secondary pb-1  col-sm-5">Reset Meeting Action</h4>
      <div class="page-title-right pb-1 col-sm-7">


        <div class="form-group position-relative float-sm-right order-sm-1">
          <input type="text" class="form-control pr-4" id="formGroupExampleInput2" placeholder="Search" [(ngModel)]="searchText" (keyup)="loadGeneralInfo(true);" [ngModelOptions]="{standalone: true}">
          <button class="position-absolute position-top-8 border-0 bg-white position-right-5 d-block p-0"><i class="la la-search fa-lg text-secondary rotate-icon"></i></button>
        </div>

      </div>
    </div>
    <div class="loader-bg" *ngIf="isLoader"></div>
    <div *ngIf="resetMeetingList==null ||resetMeetingList.length<=0 && !isLoader" class="border px-3 py-4 text-center rounded text-secondary">
      <!--<img src="{{noDataImage}}" alt="No Data" />-->
      <h5 class="pb-4 pt-2">No Data Available</h5>
    </div>
    <div class="card rounded pt-2 h-100" *ngFor="let item of resetMeetingList">
      <div class="pt-2 px-3 pb-3 border-bottom-0">
        <ng-container *ngIf="item.approvalStatus =='Draft' && item.enteredBy ==loginUserId; else newDeb">
          <div class="cover-div w-100 h-100"></div>
          <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer">{{item.subjectAtd}}</h6>
        </ng-container>
        <ng-template #newDeb>
          <div class="cover-div w-100 h-100"></div>
          <h6 class="card-title d-sm-inline d-block f-bold-dubai pr-4 pointer">{{item.subjectAtd}}</h6>
        </ng-template>
        <div class="card-controls float-right">
          <button class="btn btn-success border" (click)="resetAction(item.published,item.genInfoAtdUno)">Submit Action</button>
        </div>
        <div class="py-1">
          <span class="text-secondary" *ngIf="item.approvalStatus =='Draft'">{{item.approvalStatus}}</span>
          <span class="text-warning" *ngIf="item.approvalStatus =='Under Review' || item.approvalStatus =='Reviewed'">{{item.approvalStatusView}}</span>
          <span class="text-primary" *ngIf="item.approvalStatus =='Approved'|| item.approvalStatus == 'Pending Approval'">{{item.approvalStatusView}}</span>
          <span class="text-success" *ngIf="item.approvalStatus =='Published'">{{item.approvalStatus}}</span>
        </div>
        <div class="p-0 sm-small-size">
          <span class="pr-2"><i class="la la-calendar-o fa-lg"></i><span class="d-day">{{item.fMeetingDateAtd |  date:'EEE'}}</span>   {{item.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time">{{item.fStartTimeAtd | timeFormat}} - {{item.fEndTimeAtd | timeFormat}}</span></span> |<span class="px-2"><i class="fa fa-group"></i> {{item.meetingName}}</span>|  <span class="px-2"><i class="la la-map-marker fa-lg"></i> {{item.locationName !=''?item.locationName:'NA'}}</span> | <span class="px-2"><b class="text-secondary">Initiator:</b> {{item.initiatedBy}}</span>
        </div>
      </div>
    </div>
  </div>
